/* Essaluna Shopify theme: menu, cart drawer (Shopify Cart API), product page, collection filters */
(function () {
  'use strict';
  var T = window.theme || { strings: {}, routes: {} };
  var S = T.strings || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function group(n, d, thousands, decimal) {
    var parts = n.toFixed(d).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }
  function money(cents) {
    var v = cents / 100, whole = cents % 100 === 0;
    var fmt = (T.moneyFormat || '{{amount}}').replace(/<[^>]*>/g, '');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return group(v, 0, ',', '.');
        case 'amount_with_comma_separator': return group(v, whole ? 0 : 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(v, whole ? 0 : 2, "'", '.');
        default: return group(v, whole ? 0 : 2, ',', '.');
      }
    });
  }

  /* ---------- mobile nav ---------- */
  var menuBtn = $('.menu-btn'), nav = $('#site-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('#cart-drawer'), overlay = $('#overlay'), list = $('#cart-items'),
      totalEl = $('#cart-total'), checkout = $('#drawer-checkout'), lastFocus = null;

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (b) { b.textContent = n; b.classList.toggle('on', n > 0); });
    var btn = $('#cart-btn');
    if (btn) btn.setAttribute('aria-label', (S.cart || 'Cart') + ', ' + n);
  }

  function request(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }
  function getCart() {
    return fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    setCount(cart.item_count);
    if (!list) return;
    list.innerHTML = '';
    if (!cart.items.length) {
      var e = document.createElement('li');
      e.className = 'empty'; e.style.display = 'block'; e.style.border = '0';
      e.textContent = S.empty || '';
      list.appendChild(e);
    }
    cart.items.forEach(function (item) {
      var li = document.createElement('li');
      if (item.image) {
        var img = document.createElement('img');
        img.className = 'cart-thumb'; img.src = item.image; img.alt = ''; img.width = 64; img.height = 80; img.loading = 'lazy';
        li.appendChild(img);
      } else {
        li.appendChild(document.createElement('span'));
      }
      var meta = document.createElement('div'); meta.className = 'meta';
      var a = document.createElement('a');
      a.href = item.url; a.textContent = item.product_title; a.style.fontWeight = '600';
      meta.appendChild(a);
      if (item.variant_title) {
        var v = document.createElement('span'); v.className = 'sub'; v.textContent = item.variant_title; meta.appendChild(v);
      }
      var price = document.createElement('span');
      price.textContent = money(item.final_line_price);
      li.appendChild(meta); li.appendChild(price);

      var qty = document.createElement('div'); qty.className = 'qty';
      qty.innerHTML = '<button type="button" data-d="-1"></button><input value="' + item.quantity + '" readonly><button type="button" data-d="1"></button>';
      var btns = qty.querySelectorAll('button');
      btns[0].textContent = '−'; btns[0].setAttribute('aria-label', S.decrease || '-');
      btns[1].textContent = '+'; btns[1].setAttribute('aria-label', S.increase || '+');
      qty.addEventListener('click', function (ev) {
        var d = ev.target.getAttribute && ev.target.getAttribute('data-d');
        if (d) update(item.key, item.quantity + parseInt(d, 10));
      });
      var rm = document.createElement('button');
      rm.className = 'rm'; rm.type = 'button'; rm.textContent = S.remove || '';
      rm.addEventListener('click', function () { update(item.key, 0); });
      li.appendChild(qty); li.appendChild(rm);
      list.appendChild(li);
    });
    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (checkout) checkout.disabled = !cart.items.length;
  }

  function update(key, quantity) {
    request(T.routes.change, { id: key, quantity: quantity }).then(renderCart).catch(function () {});
  }

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    getCart().then(renderCart);
    drawer.classList.add('on'); overlay.classList.add('on');
    drawer.removeAttribute('inert');
    var c = $('#cart-close'); if (c) c.focus();
  }
  function closeCart() {
    drawer.classList.remove('on'); overlay.classList.remove('on');
    drawer.setAttribute('inert', '');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('on');
    clearTimeout(toast.t); toast.t = setTimeout(function () { t.classList.remove('on'); }, 2600);
  }

  if (drawer) {
    drawer.setAttribute('inert', '');
    $('#cart-btn').addEventListener('click', function () {
      if (location.pathname.replace(/\/$/, '').split('/').pop() === 'cart') return;
      openCart();
    });
    $('#cart-close').addEventListener('click', closeCart);
    overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('on')) closeCart(); });
  }

  /* quick add buttons on cards */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-add]');
    if (!b) return;
    b.disabled = true;
    request(T.routes.add, { items: [{ id: parseInt(b.dataset.variantId, 10), quantity: 1 }] })
      .then(function () { return getCart(); })
      .then(function (c) { renderCart(c); openCart(); })
      .catch(function (err) { toast((err && err.description) || S.error || ''); })
      .then(function () { b.disabled = false; });
  });

  /* ---------- product page ---------- */
  var form = $('[data-product-form]');
  if (form) {
    var errEl = $('[data-form-error]', form), submit = $('[data-submit]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit.disabled) return;
      submit.disabled = true; errEl.hidden = true;
      fetch(T.routes.add, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { throw j; } return j; }); })
        .then(function () { return getCart(); })
        .then(function (c) { renderCart(c); openCart(); })
        .catch(function (err) { errEl.textContent = (err && (err.description || err.message)) || S.error || ''; errEl.hidden = false; })
        .then(function () { submit.disabled = false; });
    });

    var qi = $('#qty');
    $$('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qi.value = Math.min(20, Math.max(1, (parseInt(qi.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
      });
    });

    var sel = $('[data-variant-select]');
    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var now = $('[data-price-now]'), was = $('[data-price-was]');
        if (now) now.textContent = o.dataset.price;
        if (was) { was.textContent = o.dataset.compare; was.hidden = !o.dataset.compare; }
        submit.disabled = o.dataset.available !== 'true';
        try { history.replaceState(null, '', '?variant=' + sel.value); } catch (er) {}
      });
    }
  }
  var main = $('#main-img');
  $$('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      $$('.thumb').forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
      if (main) { main.src = t.dataset.src; main.srcset = t.dataset.srcset; main.alt = t.dataset.alt || ''; }
    });
  });

  /* ---------- collection: tag tabs + sort ---------- */
  var grid = $('#shop-grid');
  if (grid) {
    var tabs = $$('.tab');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        var cat = t.dataset.cat, shown = 0;
        $$('li', grid).forEach(function (li) {
          var ok = cat === 'all' || li.dataset.cat === cat;
          li.hidden = !ok; if (ok) shown++;
        });
        var c = $('#shop-count');
        if (c) c.textContent = shown + ' ' + (shown === 1 ? S.product : S.products);
      });
    });
    var sort = $('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(location.href);
        u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page');
        location.href = u.toString();
      });
    }
  }
})();
